import React, { Component } from 'react';

import { VideoPlayerContext } from './context';

class VideoPlayerConsumer extends Component {
  render() {
    return (
      <VideoPlayerContext.Consumer>
        {(context) => this.props.children(context)}
      </VideoPlayerContext.Consumer>
    );
  }
}

export default VideoPlayerConsumer;
